"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_PHOTO_UPLOAD_COUNT = exports.LEISURE_PRODUCT_CATEGORY_KEYS = exports.DOMESTIC_PRODUCT_CATEGORY_KEYS = exports.DOMESTIC_KEYWORD_KEYS = exports.LEISURE_KEYWORD_KEYS = exports.COMPANION_KEYS = exports.CATEGORY_KEYS = void 0;
/**
 * 후기 플랫폼 서비스 카테고리
 * 현재는 국내숙소와 레저까지만 확장하였으나, 점차 해외숙소 등 확장할 예정
 * @see https://yanolja.atlassian.net/wiki/spaces/yanoljareview/pages/233833560/API+-#%EC%84%9C%EB%B9%84%EC%8A%A4-%EC%B9%B4%ED%85%8C%EA%B3%A0%EB%A6%AC
 * */
exports.CATEGORY_KEYS = {
    DOMESTIC: 'DOMESTIC_ACCOMMODATION',
    LEISURE: 'DOMESTIC_LEISURE',
};
/**
 * 동행정보 키
 * @see https://yanolja.atlassian.net/wiki/spaces/yanoljareview/pages/233833560/API+-#%EB%8F%99%ED%96%89%EC%A0%95%EB%B3%B4
 * */
exports.COMPANION_KEYS = {
    ALONE: 'ALONE',
    FRIEND: 'FRIEND',
    COUPLE: 'COUPLE',
    FAMILY: 'FAMILY',
    CHILD: 'CHILD',
    BUSINESS: 'BUSINESS',
};
/**
 * 레저/티켓 장점 키워드
 * @see https://yanolja.atlassian.net/wiki/spaces/yanoljareview/pages/233833560/API+-#%EB%A0%88%EC%A0%80%2F%ED%8B%B0%EC%BC%93
 * */
exports.LEISURE_KEYWORD_KEYS = {
    NONE: 'NONE',
    REASONABLE_PRICE: 'REASONABLE_PRICE',
    CONVENIENT_PARKING: 'CONVENIENT_PARKING',
    CLEAN_FACILITIES: 'CLEAN_FACILITIES',
    FAMILY_FRIENDLY: 'FAMILY_FRIENDLY',
    VARIETY_OF_ATTRACTIONS: 'VARIETY_OF_ATTRACTIONS',
    DIVERSE_CUISINE_OPTIONS: 'DIVERSE_CUISINE_OPTIONS',
    LARGE_SCALE: 'LARGE_SCALE',
    GOOD_PHOTO_OPPORTUNITIES: 'GOOD_PHOTO_OPPORTUNITIES',
    CLEAN_WATER: 'CLEAN_WATER',
    WELL_EQUIPPED_SHOWER_ROOM: 'WELL_EQUIPPED_SHOWER_ROOM',
    PARENT_FRIENDLY: 'PARENT_FRIENDLY',
    VARIOUS_EXPERIENCE_PROGRAMS: 'VARIOUS_EXPERIENCE_PROGRAMS',
    SAFELY_MANAGED: 'SAFELY_MANAGED',
    USE_OF_LATEST_EQUIPMENT: 'USE_OF_LATEST_EQUIPMENT',
    FRIENDLY_CUSTOMER_SERVICE: 'FRIENDLY_CUSTOMER_SERVICE',
};
/**
 * 국내숙소 장점 키워드
 * @see https://yanolja.atlassian.net/wiki/spaces/yanoljareview/pages/233833560/API+-#%EC%88%99%EC%86%8C
 * 주의: 아직 미확정
 * */
exports.DOMESTIC_KEYWORD_KEYS = {
    NONE: 'NONE',
    CLEAN_ROOM: 'CLEAN_ROOM',
    CLEAN_BATHROOM: 'CLEAN_BATHROOM',
    NO_WORRY_ABOUT_ODOR: 'NO_WORRY_ABOUT_ODOR',
    PLENTY_OF_ENTERTAINMENT_IN_ROOM: 'PLENTY_OF_ENTERTAINMENT_IN_ROOM',
    COMFORTABLE_BEDDING: 'COMFORTABLE_BEDDING',
    GREAT_FOR_BARBECUE: 'GREAT_FOR_BARBECUE',
    WELL_EQUIPPED_KITCHEN: 'WELL_EQUIPPED_KITCHEN',
    NICE_SWIMMING_POOL: 'NICE_SWIMMING_POOL',
    WELL_FACILITATED_AMENITIES: 'WELL_FACILITATED_AMENITIES',
    DELICIOUS_BREAKFAST: 'DELICIOUS_BREAKFAST',
    WELL_MAINTAINED_COMMON_AREA: 'WELL_MAINTAINED_COMMON_AREA',
    FRIENDLY_CUSTOMER_SERVICE: 'FRIENDLY_CUSTOMER_SERVICE',
    QUICK_RESPONSE: 'QUICK_RESPONSE',
    CONVENIENT_PUBLIC_TRANSPORTATION: 'CONVENIENT_PUBLIC_TRANSPORTATION',
    PLENTY_OF_NEARBY_ATTRACTIONS: 'PLENTY_OF_NEARBY_ATTRACTIONS',
    GREAT_VIEW: 'GREAT_VIEW',
    FAMILY_FRIENDLY: 'FAMILY_FRIENDLY',
    GOOD_SOUNDPROOFING: 'GOOD_SOUNDPROOFING',
    GOOD_HEATING_COOLING: 'GOOD_HEATING_COOLING',
    GOOD_AMENITIES: 'GOOD_AMENITIES',
    CONVENIENT_PICKUP_SERVICE: 'CONVENIENT_PICKUP_SERVICE',
    NO_BUG_WORRIES: 'NO_BUG_WORRIES',
    CONVENIENT_PARKING: 'CONVENIENT_PARKING',
};
exports.DOMESTIC_PRODUCT_CATEGORY_KEYS = {
    HOTEL: 'HOTEL',
    MOTEL: 'MOTEL',
    PENSION: 'PENSION',
    GUEST_HOUSE: 'GUEST_HOUSE',
};
exports.LEISURE_PRODUCT_CATEGORY_KEYS = {
    NONE: 'NONE',
    THEME_PARK: 'THEME_PARK',
    WATER_PARK: 'WATER_PARK',
    KIDS: 'KIDS',
    WATER_LEISURE: 'WATER_LEISURE',
    ETC: 'ETC',
};
exports.MAX_PHOTO_UPLOAD_COUNT = 10;
